import { CLIENT_ERROR_LEVEL_ERROR } from './errors';

export const REPORT_ERROR = 'REPORT_ERROR';
export const SPARX_WEB_ERROR = 'SPARX_WEB_ERROR';

/**
 * Reports the error provided to the server and to the Prometheus monitoring
 * @param error - a string, exception or Immutable exception
 * @param frames - a stacktrace
 * @param level - level for logging the error on the server - see ./errors.js
 */
export const reportError = (error, frames = '', level = CLIENT_ERROR_LEVEL_ERROR) => ({
    type: REPORT_ERROR,
    error,
    frames,
    level,
});

/**
 * Opens the "Sparx Web error" alert.
 */
export const sparxWebError = () => ({ type: SPARX_WEB_ERROR });
